exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.multiselect__tags[data-v-3bb89ceb] {\n    height: auto !important;\n}\nimg[data-v-3bb89ceb] {\n    width: 1.5rem;\n    height: 1.5rem;\n}\n.selected-variant[data-v-3bb89ceb]:hover {\n    background: #f5f5f5;\n}\n", ""]);

